module.exports = __webpack_public_path__ + "img/showgeofence.9c85e2e2.jpg";